import React from 'react';

const SubscriptionNudge = ({ expiryStatus }) => {
  if (!expiryStatus) return null;

  return (
    <div className="w-full bg-gradient-to-r from-[#42BA85] to-[#00B5E2] py-2.5 px-4 shadow-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
        {/* <div className="w-2 h-2 rounded-full bg-white animate-pulse flex-shrink-0" /> */}
        <span className="text-white text-xs md:text-sm font-medium text-center">
          {expiryStatus}
        </span>
      </div>
    </div>
  );
};

export default SubscriptionNudge;
